import * as tslib_1 from "tslib";
import { BaseService } from '../../_helpers';
import { HttpClient } from '@angular/common/http';
import { DictionaryEntity } from '../entity/dictionaryEntity';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CategoryDictionaryService = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryDictionaryService, _super);
    function CategoryDictionaryService(http) {
        var _this = _super.call(this, 'config/categories/idAndNames', DictionaryEntity) || this;
        _this.http = http;
        return _this;
    }
    CategoryDictionaryService.ngInjectableDef = i0.defineInjectable({ factory: function CategoryDictionaryService_Factory() { return new CategoryDictionaryService(i0.inject(i1.HttpClient)); }, token: CategoryDictionaryService, providedIn: "root" });
    return CategoryDictionaryService;
}(BaseService));
export { CategoryDictionaryService };
